/*
 * 自动生成(buildDemoScript.js) — AI 填表员演示回放脚本。勿手改；改录制后重跑。
 * 已脱敏团队/成员/文件名。
 */
export interface DemoScriptEvent {
  t: number
  kind:
    | 'composeType'
    | 'userSend'
    | 'aiStart'
    | 'aiText'
    | 'aiTool'
    | 'docStatus'
    | 'askShow'
    | 'askSubmit'
  text?: string
  /** kind==='askShow'：真实 user-ask 题目(camelCase)，回放用 UserAskBlock 渲染 */
  ask?: {
    pendingId: string
    title: string
    description?: string
    questions: any[]
  }
  /** kind==='askShow'：用户当时的答案 */
  answers?: Record<string, any>
}
export interface DemoScript {
  docName: string
  totalMs: number
  events: DemoScriptEvent[]
}
const DEMO_SCRIPT: DemoScript = {
  docName: '照片台账表.xlsx',
  totalMs: 109817,
  events: [
    { t: 0, kind: 'composeType', text: '帮' },
    { t: 55, kind: 'composeType', text: '我' },
    { t: 110, kind: 'composeType', text: '把' },
    { t: 165, kind: 'composeType', text: '这' },
    { t: 220, kind: 'composeType', text: '份' },
    { t: 275, kind: 'composeType', text: '《' },
    { t: 330, kind: 'composeType', text: '照' },
    { t: 385, kind: 'composeType', text: '片' },
    { t: 440, kind: 'composeType', text: '台' },
    { t: 495, kind: 'composeType', text: '账' },
    { t: 550, kind: 'composeType', text: '表' },
    { t: 605, kind: 'composeType', text: '》' },
    { t: 660, kind: 'composeType', text: '填' },
    { t: 715, kind: 'composeType', text: '一' },
    { t: 770, kind: 'composeType', text: '下' },
    { t: 1175, kind: 'userSend', text: '帮我把这份《照片台账表》填一下' },
    { t: 1775, kind: 'docStatus', text: '识别表格结构' },
    { t: 1775, kind: 'aiStart' },
    { t: 3928, kind: 'aiText', text: '我先' },
    { t: 3928, kind: 'aiText', text: '看看这份' },
    { t: 3928, kind: 'aiText', text: '表格' },
    { t: 4706, kind: 'aiText', text: '的结构和' },
    { t: 4706, kind: 'aiText', text: '内容。' },
    { t: 5624, kind: 'aiTool', text: '读取表格' },
    { t: 5624, kind: 'aiTool', text: '读取表格' },
    { t: 8720, kind: 'aiText', text: '看清' },
    { t: 8725, kind: 'aiText', text: '了。' },
    { t: 8725, kind: 'aiText', text: '这是一份' },
    { t: 8902, kind: 'aiText', text: ' **' },
    { t: 8902, kind: 'aiText', text: '照片台账' },
    { t: 8902, kind: 'aiText', text: '表' },
    { t: 8902, kind: 'aiText', text: '**，' },
    { t: 8902, kind: 'aiText', text: '时间范围' },
    { t: 8902, kind: 'aiText', text: ' 202' },
    { t: 9012, kind: 'aiText', text: '6' },
    { t: 9032, kind: 'aiText', text: '-06' },
    { t: 9032, kind: 'aiText', text: '-01' },
    { t: 9032, kind: 'aiText', text: ' 到' },
    { t: 9032, kind: 'aiText', text: ' 202' },
    { t: 9032, kind: 'aiText', text: '6-' },
    { t: 9169, kind: 'aiText', text: '06-' },
    { t: 9187, kind: 'aiText', text: '18。' },
    { t: 9187, kind: 'aiText', text: '第' },
    { t: 9187, kind: 'aiText', text: ' 3' },
    { t: 9187, kind: 'aiText', text: ' 行（' },
    { t: 9187, kind: 'aiText', text: 'r2' },
    { t: 9462, kind: 'aiText', text: '）是' },
    { t: 9462, kind: 'aiText', text: '表头' },
    { t: 9462, kind: 'aiText', text: '，有' },
    { t: 9462, kind: 'aiText', text: ' 52' },
    { t: 9462, kind: 'aiText', text: ' 列' },
    { t: 9462, kind: 'aiText', text: '，涵盖了' },
    { t: 9739, kind: 'aiText', text: '水印' },
    { t: 9739, kind: 'aiText', text: '照片' },
    { t: 9739, kind: 'aiText', text: '的各种字段' },
    { t: 9739, kind: 'aiText', text: ':' },
    { t: 9739, kind: 'aiText', text: ' 照片' },
    { t: 9739, kind: 'aiText', text: '/视频' },
    { t: 9828, kind: 'aiText', text: '、拍摄' },
    { t: 9828, kind: 'aiText', text: '人、' },
    { t: 9828, kind: 'aiText', text: '水印' },
    { t: 9828, kind: 'aiText', text: '名称、' },
    { t: 9828, kind: 'aiText', text: '时间' },
    { t: 9828, kind: 'aiText', text: '、地点' },
    { t: 9954, kind: 'aiText', text: '、天气' },
    { t: 9964, kind: 'aiText', text: '、坐标' },
    { t: 9964, kind: 'aiText', text: '、安全隐患' },
    { t: 9964, kind: 'aiText', text: '、工程' },
    { t: 9964, kind: 'aiText', text: '名称、' },
    { t: 9964, kind: 'aiText', text: '施工内容' },
    { t: 10362, kind: 'aiText', text: '等。' },
    { t: 10362, kind: 'aiText', text: '\n\n目前只有' },
    { t: 10362, kind: 'aiText', text: '表头' },
    { t: 10362, kind: 'aiText', text: '，数据' },
    { t: 10362, kind: 'aiText', text: '行是' },
    { t: 10362, kind: 'aiText', text: '空的。' },
    { t: 10647, kind: 'aiText', text: '我需要' },
    { t: 10647, kind: 'aiText', text: '确认一下' },
    { t: 10647, kind: 'aiText', text: '理解再' },
    { t: 10647, kind: 'aiText', text: '往下走' },
    {
      t: 11747,
      kind: 'askShow',
      ask: {
        pendingId: 'call_5e610947199642a28a875d6b',
        title: '确认一下理解',
        questions: [
          {
            qid: 'biz',
            question:
              '我看这是一份「照片台账表」，时间范围 2026-06-01 到 2026-06-18，有 30 列字段（照片/视频、拍摄人、水印名称、时间、地点、工程名称、施工内容等），需要把这段时间团队拍的照片数据逐行填进这张表里 —— 理解得对不对？',
            type: 'single_choice',
            default: '对',
            label_short: '业务',
            options: [
              { value: '对', label: '对' },
              { value: '不对', label: '不对，实际是…', expands: 'text' }
            ]
          }
        ]
      },
      answers: { biz: '对' }
    },
    { t: 13047, kind: 'askSubmit' },
    { t: 13747, kind: 'docStatus', text: '确认填写范围' },
    { t: 13747, kind: 'aiStart' },
    { t: 17442, kind: 'aiText', text: '好' },
    { t: 17442, kind: 'aiText', text: '，接下来' },
    { t: 17442, kind: 'aiText', text: '确认' },
    { t: 17442, kind: 'aiText', text: '数据范围' },
    { t: 17624, kind: 'aiText', text: ' —' },
    { t: 17643, kind: 'aiText', text: ' 时间、' },
    { t: 17643, kind: 'aiText', text: '水' },
    { t: 17643, kind: 'aiText', text: '印、' },
    { t: 17643, kind: 'aiText', text: '成员，' },
    { t: 17643, kind: 'aiText', text: '一次' },
    { t: 18474, kind: 'aiText', text: '问全' },
    {
      t: 19574,
      kind: 'askShow',
      ask: {
        pendingId: 'call_1e8c240b35254c1fb72aa934',
        title: '确认要查哪些照片',
        questions: [
          {
            default: 'custom',
            expands: 'date_range',
            label: '按表格日期范围 06-01 ~ 06-18',
            options: [
              {
                label: '06-01 ~ 06-18（表格默认）',
                value: '2026-06-01~2026-06-18'
              },
              { expands: 'date_range', label: '自定义', value: 'custom' }
            ],
            qid: 'time',
            question: '要筛选哪段时间的照片？',
            type: 'single_choice',
            label_short: '时间'
          },
          {
            picker: { kind: 'watermark' },
            qid: 'watermarks',
            question: '要筛选哪种水印模板的照片？',
            type: 'picker',
            label_short: '水印'
          },
          {
            picker: { kind: 'department_member' },
            qid: 'members',
            question: '要筛选团队里谁拍的照片？',
            type: 'picker',
            label_short: '成员'
          }
        ]
      },
      answers: {
        time: '2026-06-01~2026-06-18',
        watermarks: {
          kind: 'watermark',
          watermark_ids: [],
          summary: '全部水印'
        },
        members: {
          kind: 'department_member',
          user_ids: [
            'xuser-0d7bd699-11f5-4e1d-94f1-c8ee959918a7',
            'xuser-9743dd6b-5939-4c97-81e9-55bcd6275d6d'
          ],
          department_ids: [],
          summary: '张工一名、李工'
        }
      }
    },
    { t: 20874, kind: 'askSubmit' },
    { t: 21574, kind: 'docStatus', text: '拉取照片' },
    { t: 21574, kind: 'aiStart' },
    { t: 25277, kind: 'aiText', text: '好的' },
    { t: 25277, kind: 'aiText', text: '，范围' },
    { t: 25277, kind: 'aiText', text: '明确了' },
    { t: 25483, kind: 'aiText', text: '：202' },
    { t: 25483, kind: 'aiText', text: '6' },
    { t: 25483, kind: 'aiText', text: '-06' },
    { t: 25483, kind: 'aiText', text: '-01' },
    { t: 25483, kind: 'aiText', text: ' ~' },
    { t: 25483, kind: 'aiText', text: ' 2026' },
    { t: 25702, kind: 'aiText', text: '-06' },
    { t: 25702, kind: 'aiText', text: '-' },
    { t: 25702, kind: 'aiText', text: '18，' },
    { t: 25702, kind: 'aiText', text: '全部水' },
    { t: 25702, kind: 'aiText', text: '印' },
    { t: 25702, kind: 'aiText', text: '，两位' },
    { t: 25890, kind: 'aiText', text: '成员（' },
    { t: 25890, kind: 'aiText', text: '张' },
    { t: 25890, kind: 'aiText', text: '工' },
    { t: 25890, kind: 'aiText', text: '一名、' },
    { t: 25890, kind: 'aiText', text: '李' },
    { t: 25890, kind: 'aiText', text: '工' },
    { t: 26598, kind: 'aiText', text: '）。现在' },
    { t: 26598, kind: 'aiText', text: '拉数据' },
    { t: 27985, kind: 'aiTool', text: '搜索团队照片' },
    { t: 27985, kind: 'aiTool', text: '搜索团队照片' },
    { t: 32750, kind: 'aiText', text: '16' },
    { t: 32750, kind: 'aiText', text: ' 张' },
    { t: 32750, kind: 'aiText', text: '照片。' },
    { t: 32750, kind: 'aiText', text: '先看看' },
    { t: 33013, kind: 'aiText', text: '缓存里的' },
    { t: 33013, kind: 'aiText', text: '字段分布' },
    { t: 33026, kind: 'aiText', text: '，跟' },
    { t: 33026, kind: 'aiText', text: '表格表' },
    { t: 33026, kind: 'aiText', text: '头对' },
    { t: 33026, kind: 'aiText', text: '一下' },
    { t: 34640, kind: 'aiTool', text: '匹配照片' },
    { t: 34640, kind: 'aiTool', text: '匹配照片' },
    { t: 36993, kind: 'aiTool', text: '匹配照片' },
    { t: 36993, kind: 'aiTool', text: '匹配照片' },
    { t: 39605, kind: 'aiText', text: '数据' },
    { t: 39605, kind: 'aiText', text: '拿到了。' },
    { t: 39605, kind: 'aiText', text: '16' },
    { t: 39605, kind: 'aiText', text: ' 条' },
    { t: 40068, kind: 'aiText', text: '照片，' },
    { t: 40068, kind: 'aiText', text: '现在我把' },
    { t: 40068, kind: 'aiText', text: '表格表' },
    { t: 40068, kind: 'aiText', text: '头和数据' },
    { t: 40068, kind: 'aiText', text: '字段对齐' },
    { t: 40068, kind: 'aiText', text: '，列出' },
    { t: 40161, kind: 'aiText', text: '填表' },
    { t: 40161, kind: 'aiText', text: '方案' },
    { t: 40177, kind: 'aiText', text: '：\n\n**' },
    { t: 40177, kind: 'aiText', text: '表头' },
    { t: 40177, kind: 'aiText', text: '（r' },
    { t: 40177, kind: 'aiText', text: '2）' },
    { t: 40740, kind: 'aiText', text: '与数据' },
    { t: 40740, kind: 'aiText', text: '字段对照' },
    { t: 40740, kind: 'aiText', text: '：**' },
    { t: 40740, kind: 'aiText', text: '\n\n|' },
    { t: 40740, kind: 'aiText', text: ' 表格' },
    { t: 40740, kind: 'aiText', text: '列 |' },
    { t: 40740, kind: 'aiText', text: ' 表' },
    { t: 40740, kind: 'aiText', text: '头 |' },
    { t: 40740, kind: 'aiText', text: ' 数据' },
    { t: 40740, kind: 'aiText', text: '来源 |' },
    { t: 40740, kind: 'aiText', text: ' 匹配' },
    { t: 40740, kind: 'aiText', text: '情况 |' },
    { t: 40813, kind: 'aiText', text: '\n|---|---|---|---' },
    { t: 40813, kind: 'aiText', text: '|' },
    { t: 40813, kind: 'aiText', text: '\n| A' },
    { t: 40813, kind: 'aiText', text: '(c0' },
    { t: 40813, kind: 'aiText', text: ') |' },
    { t: 40813, kind: 'aiText', text: ' 照片' },
    { t: 41099, kind: 'aiText', text: '/视频' },
    { t: 41099, kind: 'aiText', text: ' | `' },
    { t: 41099, kind: 'aiText', text: 'url' },
    { t: 41099, kind: 'aiText', text: '` |' },
    { t: 41099, kind: 'aiText', text: ' ✅ |' },
    { t: 41099, kind: 'aiText', text: '\n| B' },
    { t: 41138, kind: 'aiText', text: '(c1' },
    { t: 41138, kind: 'aiText', text: ') |' },
    { t: 41160, kind: 'aiText', text: ' 拍摄' },
    { t: 41160, kind: 'aiText', text: '人 |' },
    { t: 41160, kind: 'aiText', text: ' `user' },
    { t: 41160, kind: 'aiText', text: '_name' },
    { t: 41293, kind: 'aiText', text: '` |' },
    { t: 41293, kind: 'aiText', text: ' ✅ |' },
    { t: 41315, kind: 'aiText', text: '\n| C' },
    { t: 41315, kind: 'aiText', text: '(c2' },
    { t: 41315, kind: 'aiText', text: ') |' },
    { t: 41315, kind: 'aiText', text: ' 水' },
    { t: 41635, kind: 'aiText', text: '印名称' },
    { t: 41635, kind: 'aiText', text: ' | `' },
    { t: 41635, kind: 'aiText', text: 'watermark' },
    { t: 41635, kind: 'aiText', text: '_name`' },
    { t: 41635, kind: 'aiText', text: ' | ✅' },
    { t: 41635, kind: 'aiText', text: ' |\n|' },
    { t: 41695, kind: 'aiText', text: ' D(c' },
    { t: 41695, kind: 'aiText', text: '3' },
    { t: 41695, kind: 'aiText', text: ') |' },
    { t: 41695, kind: 'aiText', text: ' 拍摄' },
    { t: 41695, kind: 'aiText', text: '时间 |' },
    { t: 41695, kind: 'aiText', text: ' `time' },
    { t: 41785, kind: 'aiText', text: '`' },
    { t: 41785, kind: 'aiText', text: ' | ✅' },
    { t: 41825, kind: 'aiText', text: ' |\n|' },
    { t: 41825, kind: 'aiText', text: ' E(c' },
    { t: 41825, kind: 'aiText', text: '4)' },
    { t: 41825, kind: 'aiText', text: ' |' },
    { t: 41969, kind: 'aiText', text: ' 拍摄地点' },
    { t: 41993, kind: 'aiText', text: ' | `' },
    { t: 41993, kind: 'aiText', text: 'address`' },
    { t: 41993, kind: 'aiText', text: ' | ✅' },
    { t: 41993, kind: 'aiText', text: ' |\n|' },
    { t: 41993, kind: 'aiText', text: ' F(c' },
    { t: 42176, kind: 'aiText', text: '5)' },
    { t: 42176, kind: 'aiText', text: ' |' },
    { t: 42176, kind: 'aiText', text: ' 天气 |' },
    { t: 42176, kind: 'aiText', text: ' 数据' },
    { t: 42176, kind: 'aiText', text: '中无' },
    { t: 42176, kind: 'aiText', text: '此字段' },
    { t: 42337, kind: 'aiText', text: ' |' },
    { t: 42337, kind: 'aiText', text: ' ❌' },
    { t: 42360, kind: 'aiText', text: ' 留空' },
    { t: 42360, kind: 'aiText', text: ' |\n|' },
    { t: 42360, kind: 'aiText', text: ' G' },
    { t: 42360, kind: 'aiText', text: '(c6' },
    { t: 42468, kind: 'aiText', text: ') |' },
    { t: 42496, kind: 'aiText', text: ' 经' },
    { t: 42496, kind: 'aiText', text: '度 |' },
    { t: 42496, kind: 'aiText', text: ' 数据' },
    { t: 42496, kind: 'aiText', text: '中无' },
    { t: 42496, kind: 'aiText', text: '此字段' },
    { t: 42681, kind: 'aiText', text: ' |' },
    { t: 42681, kind: 'aiText', text: ' ❌' },
    { t: 42681, kind: 'aiText', text: ' 留' },
    { t: 42681, kind: 'aiText', text: '空 |' },
    { t: 42681, kind: 'aiText', text: '\n| H' },
    { t: 42681, kind: 'aiText', text: '(c7' },
    { t: 42742, kind: 'aiText', text: ') |' },
    { t: 42742, kind: 'aiText', text: ' 纬度' },
    { t: 42768, kind: 'aiText', text: ' |' },
    { t: 42768, kind: 'aiText', text: ' 数据中' },
    { t: 42768, kind: 'aiText', text: '无此' },
    { t: 42768, kind: 'aiText', text: '字段 |' },
    { t: 42906, kind: 'aiText', text: ' ❌' },
    { t: 42906, kind: 'aiText', text: ' 留' },
    { t: 42906, kind: 'aiText', text: '空 |' },
    { t: 42906, kind: 'aiText', text: '\n| I' },
    { t: 42906, kind: 'aiText', text: '(c8' },
    { t: 42906, kind: 'aiText', text: ') |' },
    { t: 43041, kind: 'aiText', text: ' 海拔' },
    { t: 43071, kind: 'aiText', text: ' |' },
    { t: 43071, kind: 'aiText', text: ' 数据中' },
    { t: 43071, kind: 'aiText', text: '无此' },
    { t: 43071, kind: 'aiText', text: '字段 |' },
    { t: 43071, kind: 'aiText', text: ' ❌' },
    { t: 43184, kind: 'aiText', text: ' 留' },
    { t: 43215, kind: 'aiText', text: '空 |' },
    { t: 43215, kind: 'aiText', text: '\n| J' },
    { t: 43215, kind: 'aiText', text: '(c9' },
    { t: 43215, kind: 'aiText', text: ') |' },
    { t: 43215, kind: 'aiText', text: ' 安全隐患' },
    { t: 43388, kind: 'aiText', text: ' |' },
    { t: 43388, kind: 'aiText', text: ' 水印' },
    { t: 43388, kind: 'aiText', text: '字段' },
    { t: 43388, kind: 'aiText', text: ' `安全隐患' },
    { t: 43388, kind: 'aiText', text: '` |' },
    { t: 43388, kind: 'aiText', text: ' ✅' },
    { t: 43593, kind: 'aiText', text: '（16' },
    { t: 43593, kind: 'aiText', text: '条中' },
    { t: 43619, kind: 'aiText', text: '全部' },
    { t: 43619, kind: 'aiText', text: '为空）' },
    { t: 43619, kind: 'aiText', text: ' |\n|' },
    { t: 43619, kind: 'aiText', text: ' K(c' },
    { t: 43734, kind: 'aiText', text: '10)' },
    { t: 43734, kind: 'aiText', text: ' |' },
    { t: 43734, kind: 'aiText', text: ' 备注' },
    { t: 43734, kind: 'aiText', text: ' |' },
    { t: 43734, kind: 'aiText', text: ' 无对应' },
    { t: 43734, kind: 'aiText', text: ' |' },
    { t: 43839, kind: 'aiText', text: ' ❌' },
    { t: 43874, kind: 'aiText', text: ' 留' },
    { t: 43874, kind: 'aiText', text: '空 |' },
    { t: 43874, kind: 'aiText', text: '\n| L' },
    { t: 43874, kind: 'aiText', text: '(c11' },
    { t: 43874, kind: 'aiText', text: ') |' },
    { t: 43978, kind: 'aiText', text: ' 工程' },
    { t: 44015, kind: 'aiText', text: '名称 |' },
    { t: 44015, kind: 'aiText', text: ' 水' },
    { t: 44015, kind: 'aiText', text: '印字段' },
    { t: 44015, kind: 'aiText', text: ' `工程' },
    { t: 44015, kind: 'aiText', text: '名称`' },
    { t: 44104, kind: 'aiText', text: ' | ✅' },
    { t: 44136, kind: 'aiText', text: '（16' },
    { t: 44136, kind: 'aiText', text: '条中' },
    { t: 44136, kind: 'aiText', text: '全部为空' },
    { t: 44136, kind: 'aiText', text: '） |' },
    { t: 44136, kind: 'aiText', text: '\n| M' },
    { t: 44334, kind: 'aiText', text: '(c12' },
    { t: 44334, kind: 'aiText', text: ') |' },
    { t: 44334, kind: 'aiText', text: ' 青' },
    { t: 44334, kind: 'aiText', text: '桔单车' },
    { t: 44334, kind: 'aiText', text: ' |' },
    { t: 44334, kind: 'aiText', text: ' 无' },
    { t: 44556, kind: 'aiText', text: '对应 |' },
    { t: 44556, kind: 'aiText', text: ' ❌' },
    { t: 44556, kind: 'aiText', text: ' 留' },
    { t: 44556, kind: 'aiText', text: '空 |' },
    { t: 44556, kind: 'aiText', text: '\n| N' },
    { t: 44556, kind: 'aiText', text: '(c13' },
    { t: 44790, kind: 'aiText', text: ') |' },
    { t: 44790, kind: 'aiText', text: ' 班' },
    { t: 44790, kind: 'aiText', text: '前早' },
    { t: 44790, kind: 'aiText', text: '会 |' },
    { t: 44790, kind: 'aiText', text: ' 水' },
    { t: 44790, kind: 'aiText', text: '印字段' },
    { t: 44838, kind: 'aiText', text: ' `班' },
    { t: 44838, kind: 'aiText', text: '前早' },
    { t: 44838, kind: 'aiText', text: '会`' },
    { t: 44838, kind: 'aiText', text: ' | ✅' },
    { t: 44838, kind: 'aiText', text: '（16' },
    { t: 44838, kind: 'aiText', text: '条中' },
    { t: 44981, kind: 'aiText', text: '全部为空' },
    { t: 45022, kind: 'aiText', text: '） |' },
    { t: 45022, kind: 'aiText', text: '\n| O' },
    { t: 45022, kind: 'aiText', text: '(c14' },
    { t: 45022, kind: 'aiText', text: ') |' },
    { t: 45022, kind: 'aiText', text: ' 大' },
    { t: 45160, kind: 'aiText', text: '标题 |' },
    { t: 45201, kind: 'aiText', text: ' 无' },
    { t: 45201, kind: 'aiText', text: '对应 |' },
    { t: 45201, kind: 'aiText', text: ' ❌' },
    { t: 45201, kind: 'aiText', text: ' 留' },
    { t: 45201, kind: 'aiText', text: '空 |' },
    { t: 45334, kind: 'aiText', text: '\n| P' },
    { t: 45334, kind: 'aiText', text: '(c15' },
    { t: 45364, kind: 'aiText', text: ') |' },
    { t: 45364, kind: 'aiText', text: ' （空' },
    { t: 45364, kind: 'aiText', text: '） |' },
    { t: 45364, kind: 'aiText', text: ' —' },
    { t: 45534, kind: 'aiText', text: ' |' },
    { t: 45534, kind: 'aiText', text: ' 留空' },
    { t: 45569, kind: 'aiText', text: ' |\n|' },
    { t: 45569, kind: 'aiText', text: ' Q(c' },
    { t: 45569, kind: 'aiText', text: '16)' },
    { t: 45569, kind: 'aiText', text: ' |' },
    { t: 45649, kind: 'aiText', text: ' 施工安全' },
    { t: 45690, kind: 'aiText', text: ' |' },
    { t: 45690, kind: 'aiText', text: ' 水' },
    { t: 45690, kind: 'aiText', text: '印字段' },
    { t: 45690, kind: 'aiText', text: ' `施工' },
    { t: 45690, kind: 'aiText', text: '安全' },
    { t: 45832, kind: 'aiText', text: '` |' },
    { t: 45878, kind: 'aiText', text: ' ✅ |' },
    { t: 45878, kind: 'aiText', text: '\n| R' },
    { t: 45878, kind: 'aiText', text: '(c17' },
    { t: 45878, kind: 'aiText', text: ') |' },
    { t: 45878, kind: 'aiText', text: ' 施工' },
    { t: 46180, kind: 'aiText', text: '区域 |' },
    { t: 46180, kind: 'aiText', text: ' 水' },
    { t: 46180, kind: 'aiText', text: '印字段' },
    { t: 46180, kind: 'aiText', text: ' `施工' },
    { t: 46180, kind: 'aiText', text: '区域`' },
    { t: 46180, kind: 'aiText', text: ' | ✅' },
    { t: 46234, kind: 'aiText', text: ' |\n|' },
    { t: 46234, kind: 'aiText', text: ' S(c' },
    { t: 46234, kind: 'aiText', text: '18' },
    { t: 46234, kind: 'aiText', text: ') |' },
    { t: 46234, kind: 'aiText', text: ' 描述' },
    { t: 46234, kind: 'aiText', text: ' |' },
    { t: 46372, kind: 'aiText', text: ' 无对应' },
    { t: 46372, kind: 'aiText', text: ' |' },
    { t: 46372, kind: 'aiText', text: ' ❌' },
    { t: 46372, kind: 'aiText', text: ' 留空' },
    { t: 46372, kind: 'aiText', text: ' |\n|' },
    { t: 46372, kind: 'aiText', text: ' T(c' },
    { t: 46546, kind: 'aiText', text: '19)' },
    { t: 46546, kind: 'aiText', text: ' |' },
    { t: 46546, kind: 'aiText', text: ' 安全巡检' },
    { t: 46546, kind: 'aiText', text: ' |' },
    { t: 46546, kind: 'aiText', text: ' 水印' },
    { t: 46546, kind: 'aiText', text: '字段 `' },
    { t: 46635, kind: 'aiText', text: '安全巡检' },
    { t: 46635, kind: 'aiText', text: '`' },
    { t: 46635, kind: 'aiText', text: ' | ✅' },
    { t: 46635, kind: 'aiText', text: '（16' },
    { t: 46635, kind: 'aiText', text: '条中' },
    { t: 46635, kind: 'aiText', text: '全部为空' },
    { t: 46897, kind: 'aiText', text: '） |' },
    { t: 46897, kind: 'aiText', text: '\n| U' },
    { t: 46897, kind: 'aiText', text: '(c20' },
    { t: 46897, kind: 'aiText', text: ') |' },
    { t: 46897, kind: 'aiText', text: ' 是否' },
    { t: 46897, kind: 'aiText', text: '验票' },
    { t: 46985, kind: 'aiText', text: ' |' },
    { t: 46985, kind: 'aiText', text: ' 无对应' },
    { t: 46985, kind: 'aiText', text: ' |' },
    { t: 46985, kind: 'aiText', text: ' ❌' },
    { t: 46985, kind: 'aiText', text: ' 留空' },
    { t: 46985, kind: 'aiText', text: ' |\n|' },
    { t: 47136, kind: 'aiText', text: ' V(c' },
    { t: 47136, kind: 'aiText', text: '21)' },
    { t: 47183, kind: 'aiText', text: ' |' },
    { t: 47183, kind: 'aiText', text: ' 施工内容' },
    { t: 47183, kind: 'aiText', text: ' |' },
    { t: 47183, kind: 'aiText', text: ' 水印' },
    { t: 47273, kind: 'aiText', text: '字段' },
    { t: 47273, kind: 'aiText', text: ' `施工' },
    { t: 47316, kind: 'aiText', text: '内容`' },
    { t: 47316, kind: 'aiText', text: ' | ✅' },
    { t: 47316, kind: 'aiText', text: ' |\n|' },
    { t: 47316, kind: 'aiText', text: ' W' },
    { t: 47535, kind: 'aiText', text: '(c22' },
    { t: 47535, kind: 'aiText', text: ') |' },
    { t: 47535, kind: 'aiText', text: ' 运维' },
    { t: 47535, kind: 'aiText', text: '人员 |' },
    { t: 47574, kind: 'aiText', text: ' 无' },
    { t: 47574, kind: 'aiText', text: '对应 |' },
    { t: 47607, kind: 'aiText', text: ' ❌' },
    { t: 47655, kind: 'aiText', text: ' 留空' },
    { t: 47655, kind: 'aiText', text: ' |\n|' },
    { t: 47655, kind: 'aiText', text: ' X(c' },
    { t: 47655, kind: 'aiText', text: '23)' },
    { t: 47736, kind: 'aiText', text: ' |' },
    { t: 47795, kind: 'aiText', text: ' 施工' },
    { t: 47795, kind: 'aiText', text: '责任人 |' },
    { t: 47795, kind: 'aiText', text: ' 水' },
    { t: 47795, kind: 'aiText', text: '印字段' },
    { t: 47795, kind: 'aiText', text: ' `施工' },
    { t: 47955, kind: 'aiText', text: '责任人`' },
    { t: 47955, kind: 'aiText', text: ' | ✅' },
    { t: 47955, kind: 'aiText', text: '（16' },
    { t: 47955, kind: 'aiText', text: '条中' },
    { t: 47955, kind: 'aiText', text: '全部为空' },
    { t: 47955, kind: 'aiText', text: '） |' },
    { t: 48118, kind: 'aiText', text: '\n| Y' },
    { t: 48118, kind: 'aiText', text: '(c24' },
    { t: 48118, kind: 'aiText', text: ') |' },
    { t: 48118, kind: 'aiText', text: ' 本' },
    { t: 48118, kind: 'aiText', text: '场取' },
    { t: 48118, kind: 'aiText', text: '票数量' },
    { t: 48207, kind: 'aiText', text: ' |' },
    { t: 48207, kind: 'aiText', text: ' 无' },
    { t: 48207, kind: 'aiText', text: '对应 |' },
    { t: 48207, kind: 'aiText', text: ' ❌' },
    { t: 48207, kind: 'aiText', text: ' 留' },
    { t: 48207, kind: 'aiText', text: '空 |' },
    { t: 48475, kind: 'aiText', text: '\n| Z' },
    { t: 48475, kind: 'aiText', text: '(c25' },
    { t: 48475, kind: 'aiText', text: ')' },
    { t: 48475, kind: 'aiText', text: ' |' },
    { t: 48475, kind: 'aiText', text: ' 安全监管' },
    { t: 48475, kind: 'aiText', text: '人员 |' },
    { t: 48592, kind: 'aiText', text: ' 水' },
    { t: 48592, kind: 'aiText', text: '印字段' },
    { t: 48592, kind: 'aiText', text: ' `安全' },
    { t: 48592, kind: 'aiText', text: '监管人员' },
    { t: 48592, kind: 'aiText', text: '` |' },
    { t: 48592, kind: 'aiText', text: ' ✅（' },
    { t: 48672, kind: 'aiText', text: '16条' },
    { t: 48732, kind: 'aiText', text: '中' },
    { t: 48732, kind: 'aiText', text: '全部为空' },
    { t: 48732, kind: 'aiText', text: '） |' },
    { t: 48732, kind: 'aiText', text: '\n| AA' },
    { t: 48732, kind: 'aiText', text: '(c26' },
    { t: 49007, kind: 'aiText', text: ') |' },
    { t: 49007, kind: 'aiText', text: ' 取' },
    { t: 49007, kind: 'aiText', text: '票人' },
    { t: 49007, kind: 'aiText', text: ' |' },
    { t: 49007, kind: 'aiText', text: ' 无' },
    { t: 49007, kind: 'aiText', text: '对应 |' },
    { t: 49082, kind: 'aiText', text: ' ❌' },
    { t: 49082, kind: 'aiText', text: ' 留' },
    { t: 49082, kind: 'aiText', text: '空 |' },
    { t: 49082, kind: 'aiText', text: '\n| AB' },
    { t: 49082, kind: 'aiText', text: '(c27' },
    { t: 49082, kind: 'aiText', text: ') |' },
    { t: 49117, kind: 'aiText', text: ' 运维' },
    { t: 49177, kind: 'aiText', text: '标语 |' },
    { t: 49177, kind: 'aiText', text: ' 无' },
    { t: 49177, kind: 'aiText', text: '对应 |' },
    { t: 49177, kind: 'aiText', text: ' ❌' },
    { t: 49177, kind: 'aiText', text: ' 留' },
    { t: 49235, kind: 'aiText', text: '空 |' },
    { t: 49300, kind: 'aiText', text: '\n|' },
    { t: 49300, kind: 'aiText', text: ' AC(c' },
    { t: 49300, kind: 'aiText', text: '28)' },
    { t: 49300, kind: 'aiText', text: ' |' },
    { t: 49300, kind: 'aiText', text: ' 勘察' },
    { t: 49532, kind: 'aiText', text: '单位 |' },
    { t: 49532, kind: 'aiText', text: ' 水' },
    { t: 49532, kind: 'aiText', text: '印字段' },
    { t: 49532, kind: 'aiText', text: ' `勘察' },
    { t: 49532, kind: 'aiText', text: '单位`' },
    { t: 49532, kind: 'aiText', text: ' | ✅' },
    { t: 49613, kind: 'aiText', text: '（16' },
    { t: 49613, kind: 'aiText', text: '条中' },
    { t: 49613, kind: 'aiText', text: '全部为空' },
    { t: 49613, kind: 'aiText', text: '） |' },
    { t: 49613, kind: 'aiText', text: '\n| AD' },
    { t: 49613, kind: 'aiText', text: '(c29' },
    { t: 49720, kind: 'aiText', text: ') |' },
    { t: 49790, kind: 'aiText', text: ' 个人' },
    { t: 49790, kind: 'aiText', text: '名片（' },
    { t: 49790, kind: 'aiText', text: '自动）' },
    { t: 49790, kind: 'aiText', text: ' |' },
    { t: 49790, kind: 'aiText', text: ' 无对应' },
    { t: 50002, kind: 'aiText', text: ' |' },
    { t: 50073, kind: 'aiText', text: ' ❌' },
    { t: 50073, kind: 'aiText', text: ' 留空' },
    { t: 50073, kind: 'aiText', text: ' |\n\n共' },
    { t: 50073, kind: 'aiText', text: ' 16' },
    { t: 50073, kind: 'aiText', text: ' 条' },
    { t: 50155, kind: 'aiText', text: '数据，' },
    { t: 50155, kind: 'aiText', text: '填到' },
    { t: 50155, kind: 'aiText', text: '表头' },
    { t: 50155, kind: 'aiText', text: '下方' },
    { t: 50155, kind: 'aiText', text: '从第' },
    { t: 50155, kind: 'aiText', text: ' 4' },
    { t: 50193, kind: 'aiText', text: ' 行' },
    { t: 50259, kind: 'aiText', text: '（r' },
    { t: 50259, kind: 'aiText', text: '3）' },
    { t: 50259, kind: 'aiText', text: '开始。' },
    { t: 50259, kind: 'aiText', text: '有数据的' },
    { t: 50259, kind: 'aiText', text: '列' },
    { t: 50436, kind: 'aiText', text: '：A' },
    { t: 50436, kind: 'aiText', text: '~E' },
    { t: 50436, kind: 'aiText', text: '、' },
    { t: 50436, kind: 'aiText', text: 'Q、' },
    { t: 50436, kind: 'aiText', text: 'R、' },
    { t: 50436, kind: 'aiText', text: 'V；' },
    { t: 50762, kind: 'aiText', text: '其余水' },
    { t: 50762, kind: 'aiText', text: '印字段' },
    { t: 50762, kind: 'aiText', text: '全' },
    { t: 50762, kind: 'aiText', text: '空、' },
    { t: 50762, kind: 'aiText', text: '非水' },
    { t: 50762, kind: 'aiText', text: '印字段' },
    { t: 51459, kind: 'aiText', text: '无来源' },
    { t: 51459, kind: 'aiText', text: '，统一' },
    { t: 51459, kind: 'aiText', text: '留空' },
    {
      t: 52559,
      kind: 'askShow',
      ask: {
        pendingId: 'call_dc2a63c0774a4665b9dd0baf',
        title: '确认怎么填',
        questions: [
          {
            label_short: '确认',
            qid: 'ok',
            question:
              '16 条照片，填到表头下方，有数据的列是照片/视频、拍摄人、水印名称、时间、地点、施工安全、施工区域、施工内容，其余列留空。就按这样填进表格？',
            type: 'confirm'
          }
        ]
      },
      answers: { ok: true }
    },
    { t: 53859, kind: 'askSubmit' },
    { t: 54559, kind: 'docStatus', text: '写入表格' },
    { t: 54559, kind: 'aiStart' },
    { t: 58445, kind: 'aiText', text: '好' },
    { t: 58445, kind: 'aiText', text: '，开始' },
    { t: 58445, kind: 'aiText', text: '填。' },
    { t: 58445, kind: 'aiText', text: '先扩' },
    { t: 58644, kind: 'aiText', text: '表到' },
    { t: 58717, kind: 'aiText', text: ' 16' },
    { t: 58717, kind: 'aiText', text: ' 行' },
    { t: 58717, kind: 'aiText', text: '数据，' },
    { t: 58717, kind: 'aiText', text: '然后批量' },
    { t: 58717, kind: 'aiText', text: '填入。' },
    { t: 64933, kind: 'aiTool', text: '填写表格' },
    { t: 64933, kind: 'aiTool', text: '填写表格' },
    { t: 75536, kind: 'aiTool', text: '读取表格' },
    { t: 75536, kind: 'aiTool', text: '读取表格' },
    { t: 78444, kind: 'aiText', text: '已' },
    { t: 78444, kind: 'aiText', text: '填好' },
    { t: 78444, kind: 'aiText', text: '。16' },
    { t: 78444, kind: 'aiText', text: ' 条' },
    { t: 78766, kind: 'aiText', text: '照片全部' },
    { t: 78766, kind: 'aiText', text: '填入表格' },
    { t: 78766, kind: 'aiText', text: '，就是你' },
    { t: 78766, kind: 'aiText', text: '上传的那' },
    { t: 78766, kind: 'aiText', text: '份文件' },
    { t: 78766, kind: 'aiText', text: '，可在' },
    { t: 78881, kind: 'aiText', text: '预览里' },
    { t: 78881, kind: 'aiText', text: '核对。' },
    { t: 78941, kind: 'aiText', text: '\n\n⚠️' },
    { t: 78941, kind: 'aiText', text: ' 有' },
    { t: 78941, kind: 'aiText', text: '几点' },
    { t: 78941, kind: 'aiText', text: '说明：' },
    { t: 79147, kind: 'aiText', text: '\n- **' },
    { t: 79147, kind: 'aiText', text: 'C' },
    { t: 79147, kind: 'aiText', text: ' 列（' },
    { t: 79147, kind: 'aiText', text: '水印' },
    { t: 79147, kind: 'aiText', text: '名称）' },
    { t: 79147, kind: 'aiText', text: '**：' },
    { t: 79313, kind: 'aiText', text: '第' },
    { t: 79313, kind: 'aiText', text: ' 4' },
    { t: 79313, kind: 'aiText', text: ' 行' },
    { t: 79313, kind: 'aiText', text: '（r' },
    { t: 79313, kind: 'aiText', text: '3）' },
    { t: 79313, kind: 'aiText', text: '留' },
    { t: 79567, kind: 'aiText', text: '空，' },
    { t: 79567, kind: 'aiText', text: '该条' },
    { t: 79567, kind: 'aiText', text: '照片' },
    { t: 79567, kind: 'aiText', text: '没有水' },
    { t: 79567, kind: 'aiText', text: '印名称' },
    { t: 79567, kind: 'aiText', text: '字段' },
    { t: 79641, kind: 'aiText', text: '\n-' },
    { t: 79715, kind: 'aiText', text: ' **Q' },
    { t: 79715, kind: 'aiText', text: ' 列' },
    { t: 79715, kind: 'aiText', text: '（施工' },
    { t: 79715, kind: 'aiText', text: '安全）' },
    { t: 79715, kind: 'aiText', text: '**：' },
    { t: 79912, kind: 'aiText', text: '13/' },
    { t: 79984, kind: 'aiText', text: '16' },
    { t: 79984, kind: 'aiText', text: ' 有值' },
    { t: 79984, kind: 'aiText', text: '，仅' },
    { t: 79984, kind: 'aiText', text: '第' },
    { t: 79984, kind: 'aiText', text: ' 1' },
    { t: 80194, kind: 'aiText', text: ' 行' },
    { t: 80194, kind: 'aiText', text: '和第' },
    { t: 80252, kind: 'aiText', text: ' 17' },
    { t: 80252, kind: 'aiText', text: '、18' },
    { t: 80252, kind: 'aiText', text: ' 行' },
    { t: 80252, kind: 'aiText', text: '（王' },
    { t: 80490, kind: 'aiText', text: '工拍的' },
    { t: 80490, kind: 'aiText', text: '工程水' },
    { t: 80490, kind: 'aiText', text: '印）' },
    { t: 80490, kind: 'aiText', text: '无' },
    { t: 80490, kind: 'aiText', text: '施工安全' },
    { t: 80490, kind: 'aiText', text: '字段' },
    { t: 80579, kind: 'aiText', text: '\n- **' },
    { t: 80579, kind: 'aiText', text: 'R' },
    { t: 80579, kind: 'aiText', text: ' 列（' },
    { t: 80579, kind: 'aiText', text: '施工区域' },
    { t: 80579, kind: 'aiText', text: '）**' },
    { t: 80579, kind: 'aiText', text: '：仅' },
    { t: 80759, kind: 'aiText', text: '王' },
    { t: 80759, kind: 'aiText', text: '工拍的' },
    { t: 80759, kind: 'aiText', text: ' 2' },
    { t: 80759, kind: 'aiText', text: ' 张' },
    { t: 80759, kind: 'aiText', text: '有值' },
    { t: 80759, kind: 'aiText', text: '（"' },
    { t: 81010, kind: 'aiText', text: '哈哈哈' },
    { t: 81010, kind: 'aiText', text: '"），' },
    { t: 81010, kind: 'aiText', text: '其余' },
    { t: 81010, kind: 'aiText', text: ' 14' },
    { t: 81010, kind: 'aiText', text: ' 张' },
    { t: 81010, kind: 'aiText', text: '无此' },
    { t: 81123, kind: 'aiText', text: '字段' },
    { t: 81123, kind: 'aiText', text: '\n- **' },
    { t: 81123, kind: 'aiText', text: 'V' },
    { t: 81123, kind: 'aiText', text: ' 列（' },
    { t: 81123, kind: 'aiText', text: '施工内容' },
    { t: 81123, kind: 'aiText', text: '）**' },
    { t: 81212, kind: 'aiText', text: '：仅' },
    { t: 81212, kind: 'aiText', text: ' 1' },
    { t: 81212, kind: 'aiText', text: ' 张' },
    { t: 81212, kind: 'aiText', text: '有值' },
    { t: 81212, kind: 'aiText', text: '（"' },
    { t: 81212, kind: 'aiText', text: '11111' },
    { t: 81309, kind: 'aiText', text: '"），' },
    { t: 81380, kind: 'aiText', text: '其余' },
    { t: 81380, kind: 'aiText', text: ' 15' },
    { t: 81380, kind: 'aiText', text: ' 张' },
    { t: 81380, kind: 'aiText', text: '无此' },
    { t: 81380, kind: 'aiText', text: '字段' },
    { t: 81688, kind: 'aiText', text: '\n\n这些' },
    { t: 81688, kind: 'aiText', text: '缺失都是' },
    { t: 81688, kind: 'aiText', text: '水印' },
    { t: 81730, kind: 'aiText', text: '模板' },
    { t: 81730, kind: 'aiText', text: '不同导致的' },
    { t: 81730, kind: 'aiText', text: '，不同' },
    { t: 82025, kind: 'aiText', text: '水' },
    { t: 82025, kind: 'aiText', text: '印模板' },
    { t: 82025, kind: 'aiText', text: '包含的' },
    { t: 82025, kind: 'aiText', text: '字段不一样' },
    {
      t: 83125,
      kind: 'askShow',
      ask: {
        pendingId: 'call_378d3db843c944b38ebbbc93',
        title: '保存填写模板',
        questions: [
          {
            label_short: '存模板',
            qid: 'save',
            question: '把这次的填法存下来，下次同类照片台账表直接使用？',
            type: 'confirm'
          }
        ]
      },
      answers: { save: true }
    },
    { t: 84425, kind: 'askSubmit' },
    { t: 85125, kind: 'docStatus', text: '完成' },
    { t: 85125, kind: 'aiStart' },
    { t: 89240, kind: 'aiTool', text: '读取当前文档' },
    { t: 89240, kind: 'aiTool', text: '读取当前文档' },
    { t: 106040, kind: 'aiTool', text: '保存为模板' },
    { t: 106040, kind: 'aiTool', text: '保存为模板' },
    { t: 108865, kind: 'aiText', text: '已' },
    { t: 108865, kind: 'aiText', text: '保存。' },
    { t: 108865, kind: 'aiText', text: '下次在' },
    { t: 108865, kind: 'aiText', text: '模板' },
    { t: 108928, kind: 'aiText', text: '库选' },
    { t: 108928, kind: 'aiText', text: '「照片' },
    { t: 108993, kind: 'aiText', text: '台账表' },
    { t: 108993, kind: 'aiText', text: '填写」' },
    { t: 108993, kind: 'aiText', text: '就能直接' },
    { t: 108993, kind: 'aiText', text: '复用这次的' },
    { t: 109117, kind: 'aiText', text: '填法' },
    { t: 109117, kind: 'aiText', text: '。' }
  ]
}
export default DEMO_SCRIPT
